export enum RentalRows {
    Rental = 'Rental',
    BuildFixRent = 'Build / Fix Rent',
    DSCR = 'DSCR',
}
